import { render, staticRenderFns } from "./ProductInciList.vue?vue&type=template&id=05e8dd2a&scoped=true&"
import script from "./ProductInciList.vue?vue&type=script&lang=js&"
export * from "./ProductInciList.vue?vue&type=script&lang=js&"
import style0 from "./ProductInciList.vue?vue&type=style&index=0&id=05e8dd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e8dd2a",
  null
  
)

export default component.exports